var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content", attrs: { id: "qa" } }, [
    _c("h2", { staticClass: "m-n" }, [_vm._v("Q&A")]),
    _vm._v(" "),
    _vm.pageData.length && _vm.latestUpdated
      ? _c("div", { staticStyle: { padding: "20px" } }, [
          _vm._v("最終更新日： " + _vm._s(_vm.latestUpdated))
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "hpanel panel-group",
        attrs: {
          id: "accordion",
          role: "tablist",
          "aria-multiselectable": "true"
        }
      },
      [
        _vm._l(_vm.pageData, function(item) {
          return [
            _c("div", { key: item.groupId, staticClass: "panel-body" }, [
              _c("h4", {
                staticClass: "m-t-none m-b-none",
                domProps: {
                  innerHTML: _vm._s(_vm.replaceHTMLSellerInfo(item.groupName))
                }
              })
            ]),
            _vm._v(" "),
            _vm._l(item.data, function(qaData, index) {
              return _c(
                "div",
                {
                  key: item.groupId + "-" + index,
                  staticClass: "panel-body qa-block"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "question collapsed m-l pointer-cursor accordion-title",
                      attrs: {
                        "data-toggle": "collapse",
                        "data-parent": "#accordion",
                        "data-target": "#answer-" + item.groupId + "-" + index,
                        "aria-expanded": "false"
                      }
                    },
                    [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.replaceHTMLSellerInfo(qaData.title)
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass:
                          "fa fa-chevron-down accordion-arrow text-muted"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "panel-collapse collapse m-l",
                      attrs: {
                        id: "answer-" + item.groupId + "-" + index,
                        "aria-expanded": "true"
                      }
                    },
                    [
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "m-l",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.replaceHTMLSellerInfo(qaData.content)
                          )
                        }
                      })
                    ]
                  )
                ]
              )
            })
          ]
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("pagination", {
          attrs: { url: "QA/list" },
          on: { onChangePage: _vm.onChangePage }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68936ac5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68936ac5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/QuestionAnswer.vue
// module id = null
// module chunks = 